import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import AppRegistration from "@mui/icons-material/AppRegistration";

import Layout from "../components/Layout";
import { useApiStore } from "../store";
import useI18n from "../hooks/useI18n";

const RegisterScreen = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const { clearLocalStorage, register } = useApiStore((state) => state);

  useEffect(
    () => {
      clearLocalStorage();
    },
    // eslint-disable-next-line
    []
  );

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email")?.toString() || "";
    const username = data.get("username")?.toString() || "";
    const password = data.get("password")?.toString() || "";
    const phoneNumber = data.get("phoneNumber")?.toString() || "";
    const firstName = data.get("firstName")?.toString() || "";
    const lastName = data.get("lastName")?.toString() || "";
    const ministryJustification = data.get("ministryJustification")?.toString() || "";
    const mailingAddress = data.get("mailingAddress")?.toString() || "";

    const success = await register(
      email,
      username,
      password,
      phoneNumber,
      firstName,
      lastName,
      ministryJustification,
      mailingAddress
    );
    if (success) navigate(`/signin`);
  };

  return (
    <Layout>
      <Container component="main" sx={{ maxWidth: { xs: "sm", md: "sm" } }}>
        <Paper
          sx={{
            marginTop: 8,
            padding: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <AppRegistration />
          </Avatar>
          <Typography component="h1" variant="h5">
            {t("auth.register")}
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={t("auth.email")}
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label={t("auth.username")}
              name="username"
              autoComplete="username"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label={t("auth.password")}
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="phoneNumber"
              label={t("auth.phone")}
              type="phoneNumber"
              id="phoneNumber"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="firstName"
              label={t("auth.first_name")}
              type="firstName"
              id="firstName"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="lastName"
              label={t("auth.last_name")}
              type="lastName"
              id="lastName"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="mailingAddress"
              label={t("auth.mailing_address")}
              id="mailingAddress"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="ministryJustification"
              label={t("auth.ministry_justification")}
              id="ministryJustification"
              multiline
              rows={3}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              size="large"
            >
              {t("auth.register")}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default RegisterScreen;
